export default "__VITE_ASSET__HEY0LGYD__"